import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
declare var $: any;
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';
@Component({
  selector: 'app-employee-history',
  templateUrl: './employee-history.component.html',
  styleUrls: ['./employee-history.component.scss']
})
export class EmployeeHistoryComponent implements OnInit {
  uuid: any;
  response:any;
  employeeDetails:any;
  constructor(private router: Router,
    private api: ApiService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private location: Location,
    private ngxUiLoaderService: NgxUiLoaderService,
    private snackBar: MatSnackBar) {
    
    if (this.route.snapshot.paramMap.get('id')) {
      this.uuid = this.route.snapshot.paramMap.get('id');
      if(this.uuid ){
        this.getEmployeeResignData()
      }
      else{
        this.location.back();
      }
      console.log("44", this.uuid)
    }
  }

  ngOnInit() {}
  getEmployeeResignData() {
    this.ngxUiLoaderService.start();
    this.api.getEmployeeResignDetails(this.uuid).pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            console.log("121", data)
            this.employeeDetails = this.response.results.employee;
             console.log("121", this.employeeDetails)
          } else {
            this.snackBar.open(this.response.message, "OK", {
              duration: 5000,
            });
          }

        },
        error => {
          this.ngxUiLoaderService.stop();
        });

  }
  goback() {
    this.location.back();
  }
}
